import React, { useState, useEffect, useRef, memo } from "react";
import { Chart } from "primereact/chart";
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { CommonBodyForTable } from "../Common/CommonComponents";
// Service
import ApiServices from "../../service/api/ApiServices";
import { barDataForBarChart, barOptionsForBarChart } from "../Common/CommonFunctions";
const apiServices = new ApiServices();
const AllMachineConsumptionChart = (props) => {
    const [allData, setAllData] = useState(null);
    const [dataLabels, setDataLabels] = useState([]);
    const [dataValues, setDataValues] = useState([]);
    const [loading, setLoading] = useState(true);
    const dt = useRef(null);
    useEffect(() => {
        getData(props.machineIds, props.date, props.machineData);
    }, [props.machineIds, props.date, props.machineData]);
    const getData = async (machineIds, date, machineData) => {
        if (!machineIds || machineIds.length === 0) {
            setAllData(null);
            setDataLabels([]);
            setDataValues([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        try {
            const results = await Promise.all(
                machineIds.map((machineId) =>
                    apiServices.getMachineConsumption({ id: [machineId], date, beverage: 'All' })
                )
            );
            const raw = machineIds.map((machineId, index) => {
                const rows = results[index]?.data?.data || [];
                const totalCups = rows.reduce((sum, row) => sum + (row.cups || 0), 0);
                const matchedMachine = machineData?.find((m) => m.id === machineId);
                const label = matchedMachine?.siteName || matchedMachine?.companyName || machineId;

                // Included machineId as a property for the export table
                return {
                    machineId: machineId,
                    name: label,
                    cups: totalCups
                };
            });
            setAllData(raw);
            setDataLabels(machineIds); // Sets machine IDs for chart X-axis
            setDataValues(raw.map(a => a.cups));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }
    const exportCSV = () => { dt.current.exportCSV(); }
    const barData = barDataForBarChart(dataLabels, dataValues, 'Total Cups');

    const baseBarOptions = barOptionsForBarChart('Machine', 'Total Cup Count');
    const barOptions = {
        ...baseBarOptions,
        scales: {
            ...baseBarOptions.scales,
            x: {
                ...baseBarOptions.scales?.x,
                ticks: {
                    ...baseBarOptions.scales?.x?.ticks,
                    display: true // Shows machine IDs on the X-axis
                }
            }
        }
    };
    return (
        <>
            <div className="p-col-12">
                <div className="card widget-visitor-graph">
                    <div className="card-header">
                        <span></span>
                        <div className='p-col-sm-4'>
                            <Button icon="pi pi-download" title='Download Report' className="p-button-rounded p-button-primary p-mr-2 p-mb-2" onClick={exportCSV} />
                        </div>
                    </div>
                    {
                        loading ?
                            <div className='spinner-div'>
                                <center><ProgressSpinner strokeWidth={7} animationDuration='4s' /></center>
                            </div> :
                            <div className="graph">
                                <Chart type="bar" data={barData} options={barOptions} />
                            </div>
                    }
                </div>
            </div>
            {/* DataTable updated to include Machine ID in the export file */}
            <DataTable style={{ display: 'none' }} ref={dt} value={allData} dataKey="machineId" exportFilename="All-Machine-Consumption" className="datatable-responsive" emptyMessage="No data found.">
                <Column field="machineId" header="Machine ID" body={CommonBodyForTable}></Column>
                <Column field="name" header="Machine Name / Site" body={CommonBodyForTable}></Column>
                <Column field="cups" header="Total Cup Count" body={CommonBodyForTable}></Column>
            </DataTable>
        </>
    );
};
export default memo(AllMachineConsumptionChart);
